// Mapowanie nazw krajów (PL, zgodne z src/lib/airports.ts) na regiony świata.
// Używane do filtrowania okazji po regionie docelowym.

export type Region =
  | "Europa"
  | "Azja"
  | "Bliski Wschód"
  | "Ameryka Płn."
  | "Ameryka Płd. i Karaiby"
  | "Afryka"
  | "Oceania";

export const REGIONS: Region[] = [
  "Europa",
  "Azja",
  "Bliski Wschód",
  "Ameryka Płn.",
  "Ameryka Płd. i Karaiby",
  "Afryka",
  "Oceania",
];

const COUNTRY_TO_REGION: Record<string, Region> = {
  // Europa
  Albania: "Europa", Austria: "Europa", Belgia: "Europa",
  "Bośnia i Hercegowina": "Europa", Bułgaria: "Europa", Chorwacja: "Europa",
  Cypr: "Europa", Czarnogóra: "Europa", Czechy: "Europa", Dania: "Europa",
  Estonia: "Europa", Finlandia: "Europa", Francja: "Europa", Grecja: "Europa",
  Hiszpania: "Europa", Holandia: "Europa", Irlandia: "Europa",
  Islandia: "Europa", Litwa: "Europa", Luksemburg: "Europa", Łotwa: "Europa",
  "Macedonia Północna": "Europa", Malta: "Europa", Niemcy: "Europa",
  Norwegia: "Europa", Polska: "Europa", Portugalia: "Europa",
  Rumunia: "Europa", Serbia: "Europa", Słowacja: "Europa", Słowenia: "Europa",
  Szwajcaria: "Europa", Szwecja: "Europa", Turcja: "Europa", Węgry: "Europa",
  "Wielka Brytania": "Europa", Włochy: "Europa",

  // Azja
  Armenia: "Azja", Azerbejdżan: "Azja", Chiny: "Azja", Filipiny: "Azja",
  Gruzja: "Azja", Hongkong: "Azja", Indie: "Azja", Indonezja: "Azja",
  Japonia: "Azja", Kambodża: "Azja", "Korea Płd.": "Azja", Malezja: "Azja",
  Malediwy: "Azja", Nepal: "Azja", Singapur: "Azja", "Sri Lanka": "Azja",
  Tajlandia: "Azja", Tajwan: "Azja", Wietnam: "Azja",

  // Bliski Wschód
  "Arabia Saudyjska": "Bliski Wschód", Bahrajn: "Bliski Wschód",
  Izrael: "Bliski Wschód", Jordania: "Bliski Wschód", Katar: "Bliski Wschód",
  Kuwejt: "Bliski Wschód", Liban: "Bliski Wschód", Oman: "Bliski Wschód",
  ZEA: "Bliski Wschód",

  // Ameryka Płn.
  Kanada: "Ameryka Płn.", Meksyk: "Ameryka Płn.", USA: "Ameryka Płn.",

  // Ameryka Płd. i Karaiby
  Argentyna: "Ameryka Płd. i Karaiby", Bahamy: "Ameryka Płd. i Karaiby",
  Barbados: "Ameryka Płd. i Karaiby", Brazylia: "Ameryka Płd. i Karaiby",
  Chile: "Ameryka Płd. i Karaiby", Dominikana: "Ameryka Płd. i Karaiby",
  Ekwador: "Ameryka Płd. i Karaiby", Jamajka: "Ameryka Płd. i Karaiby",
  Kolumbia: "Ameryka Płd. i Karaiby", Kuba: "Ameryka Płd. i Karaiby",
  Peru: "Ameryka Płd. i Karaiby", Urugwaj: "Ameryka Płd. i Karaiby",

  // Afryka
  Egipt: "Afryka", Etiopia: "Afryka", Kenia: "Afryka", Maroko: "Afryka",
  Mauritius: "Afryka", RPA: "Afryka", Seszele: "Afryka", Tanzania: "Afryka",
  Tunezja: "Afryka",

  // Oceania
  Australia: "Oceania", Fidżi: "Oceania", "Nowa Zelandia": "Oceania",
};

export function regionOf(country: string): Region | null {
  return COUNTRY_TO_REGION[country] ?? null;
}
